<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Record</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" :dataset-id="datasetId" v-model="recordId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('bibNumber')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('bibNumber')" v-model.lazy="bibNumber">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('name')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name')" v-model.lazy="name">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('country')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country')" v-model.lazy="country">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('subtitle')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('subtitle')" v-model.lazy="subtitle">
        </div>
      </div>
      <picture-select-group v-model="portraitId" :album-id="albumId" label="Portrait"></picture-select-group>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternBibNumber')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternBibNumber')" v-model.lazy="patternBibNumber">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternName')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternName')" v-model.lazy="patternName">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternCountry')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternCountry')" v-model.lazy="patternCountry">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternSubtitle')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternSubtitle')" v-model.lazy="patternSubtitle">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternPortrait')" class="col-sm-4 col-form-label">Portrait</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternPortrait')" v-model.lazy="patternPortrait">
        </div>
      </div>
      <album-select-group v-model="albumId" label="Portraits"></album-select-group>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapImageIdToImage, mapOverlayData, mapTemplateData } from '../../utils/index'

  export default {
    name: 'uiaa-lower-third-lead',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['bibNumber', 'name', 'country', 'subtitle']),
      ...mapTemplateData(['datasetId', 'recordId', 'albumId', 'portraitId']),
      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        patternBibNumber: {default: '${BIB}'},
        patternName: {default: '${LAST NAME} ${FIRST NAME}'},
        patternCountry: {default: '${COUNTRY}'},
        patternSubtitle: {default: '${SUBTITLE}'},
        patternPortrait: {default: '${BIB}.png'}
        /* eslint-enable no-template-curly-in-string */
      }),
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      datasetColumns () {
        if (!this.dataset) return
        return this.dataset.columns || []
      }
    },
    watch: {
      recordId: function (val) {
        if (!val) return
        let record = this.$store.getters.dataset(this.datasetId).records
          .find(r => r.recordId === val)
        if (!record) return
        record = this.mapRecord(record)
        this.bibNumber = record.bibNumber
        this.name = record.name
        this.country = record.country
        this.subtitle = record.subtitle
        console.log('record', record)
        const portrait = this.$store.getters.picture(this.albumId, p => p.fileName === record.portrait)
        this.portraitId = portrait && portrait.pictureId
      },
      ...mapImageIdToImage('albumId', 'portraitId', 'portrait')
    },
    methods: {
      mapRecord (record) {
        const result = {}
        const recordMap = {
          bibNumber: this.patternBibNumber,
          name: this.patternName,
          country: this.patternCountry,
          subtitle: this.patternSubtitle,
          portrait: this.patternPortrait
        }
        for (let k in recordMap) {
          if (!recordMap.hasOwnProperty(k)) continue
          result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
            return record[p1] || ''
          })
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/uiaa-lower-third-lead.vue